// @flow

import {
  fetchCartConfigurations,
  applyTemplate,
  type CartConfiguration,
} from '@gandi/cart';

import type { Dispatch, ThunkAction } from 'src/types';

export type ApplyEmptyTemplate = (
  cartConfiguration: CartConfiguration,
) => ThunkAction<Promise<any>>;

export const applyEmptyTemplate: ApplyEmptyTemplate =
  ({ id: configId, product_type: productType, process }) =>
  async (dispatch: Dispatch) => {
    // on removal we apply an empty template to prevent to reapply a default template on applyTemplateIfNeeded
    const result = await dispatch(
      applyTemplate({
        configId,
        productType,
        process,
        templateId: null,
        templateName: null,
        templateDescription: null,
        noConflict: true,
      }),
    );

    await dispatch(fetchCartConfigurations());

    return result;
  };
